import { useLocation } from "react-router";
import { useSelector } from "react-redux";

import {
  TEMPORARY_PROFILE_DOCTOR,
  TEMPORARY_APPEALS,
  TEMPORARY_REIMB,
  CLIENT_TRAVEL,
  CLIENT_CORP_INSURANCE,
  CLIENT_INSURANCE_AND_MORE,
  CLIENT_SAERTO,
  CLIENT_STUDENT,
} from "src/containers/layout";
function ErrorMessage() {
  const currentLocation = useLocation();

  const lang = useSelector((state) => state.common.lang);

  let errorText;
  if (currentLocation?.pathname?.includes(TEMPORARY_PROFILE_DOCTOR)) {
    errorText =
      lang === "en" ? (
        <div>
          <p>
            To schedule an appointment with a family doctor or for any other
            inquiries,
          </p>
          <div>
            please contact the call center at:
            <a href="tel:+995 32 292 22 22"> +995 32 292 22 22</a>
          </div>
        </div>
      ) : (
        <div>
          <p> ოჯახის ექიმთან ჩასაწერად , გთხოვთ მიმართოთ კონტაქტ ცენტრს.</p>
          <div>
            საკონტაქტო ინფორმაცია:
            <a href="tel:+995 32 292 22 22"> +995 32 292 22 22</a>
          </div>
        </div>
      );
  } else if (currentLocation?.pathname?.includes(TEMPORARY_APPEALS)) {
    errorText =
      lang === "en" ? (
        <>
          <p className="appeals-paragraph">
            To receive referrals for ambulatory care and medication you need to
            register with your family doctor.
          </p>
          <p className="appeals-paragraph">
            You can get help with this by contacting the call center at:
            <a href="tel:+995 32 292 22 22"> +995 32 292 22 22</a>
          </p>
          <p className="appeals-paragraph indent-paragraph">
            Alternatively please send the form 100/the doctor's prescription and
            your contact information to the e-mail address:{" "}
            <a href="#">GP-Analyst@imedil.ge</a> (Please note that you should
            receive your referrals within 24 hours of submitting the form.)
          </p>
        </>
      ) : (
        <>
          <p className="appeals-paragraph">
            ამბულატორიული და მედიკამენტური მიმართვის მისაღებად, გთხოვთ ჩაეწეროთ
            ოჯახის ექიმთან, კონტაქტ ცენტრის დახმარებით.
          </p>
          <p className="appeals-paragraph">
            საკონტაქტო ინფორმაცია:
            <a href="tel:+995 32 292 22 22"> +995 32 292 22 22</a>
          </p>
          <p className="appeals-paragraph indent-paragraph">
            Მედიკამენტური და ამბულატორიული მიმართვების მისაღებად გთხოვთ ფორმა
            100/ დანიშნულება და თქვენი საკონტაქტო მონაცემები გადმოაგზავნოთ ელ
            ფოსტაზე: <a href="#">GP-Analyst@imedil.ge</a> (გაითვალისწინეთ, რომ
            მიმართვებს მიიღებთ გაგზავნიდან 24 საათის განმავლობაში)
          </p>
        </>
      );
  } else if (currentLocation?.pathname?.includes(TEMPORARY_REIMB)) {
    errorText =
      lang === "en" ? (
        <>
          <p>
            Welcome! To begin using this service, kindly follow the instructions
            provided below.
          </p>

          <p className="indent-paragraph">
            To receive compensation, please send the required documents to the
            following email addresses: - <a href="#">clientservice@imedil.ge</a>
          </p>
          <p className="indent-paragraph">
            And <a href="#">clientservice_mia@imedil.ge</a> for insured persons
            of the Ministry of Internal Affairs.
          </p>

          <ul className="mt-3">
            <li>Form 100/medical prescription </li>
            <li>
              Bank account number (parent's account number in the case of a
              minor insured)
            </li>

            <li>
              Identity Document (Please provide the birth certificate in case of
              minor insured)
            </li>
            <li>Certified cashier's receipt stamped </li>
            <li> receipt and/or a bank money order as proof of payment.</li>
            <li>Contact Information</li>
          </ul>
          <p className="mt-5">
            Alternatively, you can visit Imedi L's service centers at the
            following locations:
          </p>
          <ul>
            <li> Tbilisi - Kazbegi #44</li>
            <li>Batumi - Farnavaz Mefe #121</li>
            <li>Kutaisi - Pushkin #8</li>
            <li>Rustavi - Meskishvili #1</li>
          </ul>

          <p className="mt-3">
            Please find below the working hours for Imedi L service centers.
          </p>
          <div className="table-custom-static">
            <table className="">
              <thead>
                <tr>
                  <td></td>
                  <th>Tbilisi</th>
                  <th>Kutaisi</th>
                  <th>Batumi</th>
                </tr>
              </thead>
              <tbody>
                <tr className="table-row-underline">
                  <th>Monday to Friday</th>
                  <td>10:00-17:30</td>
                  <td>10:00-17:30</td>
                  <td>10:00-17:30</td>
                </tr>
                <tr className="table-row-underline">
                  <th>Saturday</th>
                  <td>11:00-14:00</td>
                  <td>11:00-14:00</td>
                  <td>11:00-14:00</td>
                </tr>
              </tbody>
            </table>
          </div>
        </>
      ) : (
        <>
          <p>
            მოგესალმებით, აღნიშნული სერვისით სარგებლობისთვის გთხოვთ
            იხელმძღვანელოთ ქვემოთ მოცემული ინსტრუქციით:
          </p>

          <p className="indent-paragraph">
            ანაზღაურების მისაღებად, ქვემოთ ჩამოთვლილი დოკუმენტაცია
            გადმოგვიგზავნოთ ელ ფოსტაზე - <a href="#">clientservice@imedil.ge</a>
          </p>
          <p className="indent-paragraph">
            შინაგან საქმეთა სამინისტროს დაზღვეულების შემთხვევაში -
            <a href="#">clientservice_mia@imedil.ge</a>
          </p>

          <ul className="mt-3">
            <li>ფორმა 100 / დანიშნულება </li>
            <li>
              დაზღვეულის საბანკო რეკვიზიტები (არასრულწლივანი დაზღვეულის
              შემთხვევაში მშობლის რეკვიზიტი)
            </li>
            <li>
              საიდენტიფიკაციო დოკუმენტი (არასრულწლოვანის შემთხვევაში დაბადების
              მოწმობის ასლი)
            </li>
            <li>ბეჭდით დამოწმებული სალაროს შემოსავლის ორდერი </li>
            <li>ჩეკი ან/და ბანკის საგადახდო დავალება </li>
            <li>საკონტაქტო ინფორმაცია </li>
          </ul>
          <p className="mt-5">
            საბუთების წარდგენა შეგიძლიათ იმედი ლ-ის ანაზღაურების ოფისში:
          </p>
          <ul>
            <li> თბილისი - ყაზბეგის #44</li>
            <li>ბათუმი - ფარნავაზ მეფის #121</li>
            <li>ქუთაისი - პუშკინის #8</li>
            <li>რუსთავი - მესხიშვილის #1</li>
          </ul>

          <p className="mt-3">
            იმედი ლ-ის ანაზღაურების ოფისების სამუშაო საათები:
          </p>
          <div className="table-custom-static">
            <table className="">
              <thead>
                <tr>
                  <td></td>
                  <th>თბილისი</th>
                  <th>ქუთაისი</th>
                  <th>ბათუმი</th>
                </tr>
              </thead>
              <tbody>
                <tr className="table-row-underline">
                  <th>ორშაბათი პარასკევი</th>
                  <td>10:00-17:30</td>
                  <td>10:00-17:30</td>
                  <td>10:00-17:30</td>
                </tr>
                <tr className="table-row-underline">
                  <th>შაბათი</th>
                  <td>11:00-14:00</td>
                  <td>11:00-14:00</td>
                  <td>11:00-14:00</td>
                </tr>
              </tbody>
            </table>
          </div>
        </>
      );
  } else if (currentLocation?.pathname?.includes(CLIENT_TRAVEL)) {
    errorText =
      lang === "en" ? (
        <>
          <p>
            To request travel insurance, please provide the following
            information at -<a href="#"> Desk_imedil@imedil.ge</a>:
          </p>
          <ul>
            <li>Passport photo</li>
            <li>Travel period</li>
            <li>Destination</li>
            <li>Contact information of insured person</li>
          </ul>
          <p className="pt-3">
            You can purchase travel insurance by visiting our office at the
            following address: Tbilisi - Chavchavadze #7
          </p>
          <p>
            The instruction above also refers to the corporate travel insurance.
          </p>
        </>
      ) : (
        <>
          <p>
            სამოგზაურო დაზღვევის შესაძენად, გამოაგზავნეთ მოთხოვნა ელ.ფოსტაზე:
            <a href="#"> Desk_imedil@imedil.ge</a>
          </p>
          <p>გთხოვთ მეილით მოგვაწოდოთ შემდეგი ინფორმაცია: </p>
          <ul>
            <li>პასპორტის ფოტო</li>
            <li>მოგზაურობის თარიღები</li>
            <li>მოგზაურობის ქვეყანა</li>
            <li>დაზღვეულის საკონტაქტო ინფორმაცია</li>
          </ul>
          <p className="pt-3">
            სამოგზაურო დაზღვევის შესაძენად, შეგიძლიათ მობრძანდეთ იმედი ლ-ის
            ოფისში, თბილისი - ჭავჭავაძის #7
          </p>
          <p>
            აღნიშნული ინსტრუქცია ასევე ვრცელდება კორპორატიულ სამოგზაურო
            დაზღვევაზე.
          </p>
        </>
      );
  } else if (currentLocation?.pathname?.includes(CLIENT_CORP_INSURANCE)) {
    errorText =
      lang === "en" ? (
        <>
          <p className="appeals-paragraph">
            To receive information regarding corporate insurance send request
            at: <a href="#">info@imedil.ge</a>
          </p>
        </>
      ) : (
        <>
          <p className="appeals-paragraph">
            ჯანმრთელობის კორპორატიული დაზღვევით დაინტერესების შემთხვევაში,
            გამოაგზავნეთ მოთხოვნა ელ.ფოსტაზე: <a href="#">info@imedil.ge</a>
          </p>
        </>
      );
  } else if (currentLocation?.pathname?.includes(CLIENT_INSURANCE_AND_MORE)) {
    errorText =
      lang === "en" ? (
        <>
          <p className="appeals-paragraph">
            To receive information regarding product - 'Insurance and more'
            rsend request at: <a href="#">info@imedil.ge</a>
          </p>
        </>
      ) : (
        <>
          <p className="appeals-paragraph">
            პროდუქტით - დაზღვევა და მეტი, დაინტერესების შემთხვევაში,
            გამოაგზავნეთ მოთხოვნა ელ.ფოსტაზე: <a href="#">info@imedil.ge</a>
          </p>
        </>
      );
  } else if (currentLocation?.pathname?.includes(CLIENT_SAERTO)) {
    errorText =
      lang === "en" ? (
        <>
          <p className="appeals-paragraph">
            To receive information regarding individual insurance send request
            at : <a href="#">info@imedil.ge</a>
          </p>
        </>
      ) : (
        <>
          <p className="appeals-paragraph">
            ჯანმრთელობის ინდივიდუალური დაზღვევით დაინტერესების შემთხვევაში,
            გამოაგზავნეთ მოთხოვნა ელ.ფოსტაზე: <a href="#">info@imedil.ge</a>
          </p>
        </>
      );
  } else if (currentLocation?.pathname?.includes(CLIENT_STUDENT)) {
    errorText =
      lang === "en" ? (
        <>
          <p className="appeals-paragraph">
            To purchase insurance product for foreign citizens send request at:{" "}
            <a href="#">Desk_imedil@imedil.ge</a>
          </p>
        </>
      ) : (
        <>
          <p className="appeals-paragraph">
            უცხო ქვეყნის მოქალაქეებისთვის განკუთვნილი სადაზღვევო პროდუქტის
            შესაძენად, გამოაგზავნეთ მოთხოვნა ელ.ფოსტაზე:{" "}
            <a href="#">Desk_imedil@imedil.ge</a>
          </p>
        </>
      );
  }
  return (
    <div>
      <div className="error-module-page">
        <div className="error-in-modules-container-blue ">
          <div className="error-in-modules">
            <div className="text-error-in-modules">{errorText}</div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ErrorMessage;
